<template>
  <div class="section-usp">
    <div class="container">
      <div class="row">
        <div class="col-6 col-md-3">
          <div class="section-usp-element">
            <div class="section-usp-element-image">
              <SfImage src="/assets/custom/icons/icon-click-collect.svg" />
            </div>
            <div class="section-usp-element-content">
              <div class="section-usp-element-title">
                Click & collect
              </div>
              <div class="section-usp-element-description">
                Online kaufen und selbst in einem unserer RuckZuck- Märkte abholen.
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-3">
          <div class="section-usp-element">
            <div class="section-usp-element-image">
              <SfImage src="/assets/custom/icons/icon-free-sample.svg" />
            </div>
            <div class="section-usp-element-content">
              <div class="section-usp-element-title">
                Gratis Muster
              </div>
              <div class="section-usp-element-description">
                Zuhause vergleichen. Bestellen Sie bis zu 2 Gratis Muster.
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-3 desktop-only">
          <div class="section-usp-element">
            <div class="section-usp-element-image">
              <SfImage src="/assets/custom/icons/icon-all-in-sw.svg" />
              <!--img src="/assets/custom/icons/icon-insulation.svg"-->
            </div>
            <div class="section-usp-element-content">
              <div class="section-usp-element-title">
                Fußleiste & Dämmung inklusive
              </div>
              <div class="section-usp-element-description">
                Entspricht mindestens der bestellten Fläche (m²) des Bodenbelags.
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-3 desktop-only">
          <div class="section-usp-element">
            <router-link :to="localizedRoute('/trusted-shops-kaeuferschutz')" class="section-usp-element-image">
              <SfImage src="/assets/custom/icons/icon-trusted-shops-sw.svg" />
            </router-link>
            <div class="section-usp-element-content">
              <div class="section-usp-element-title">
                Trusted Shops
              </div>
              <div class="section-usp-element-description">
                Gütesiegel mit Käuferschutz für sicheres Einkaufen im Internet.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SfImage } from '@storefront-ui/vue';

export default {
  name: 'MSectionUsp',
  components: {
    SfImage
  },
  props: {
  }
};
</script>

<style lang="scss" scoped>
</style>
